export default __webpack_public_path__ + "static/media/img1.2206e190.jpg";